import { render } from "./FoodMapView.vue?vue&type=template&id=56d26425&scoped=true"
import script from "./FoodMapView.vue?vue&type=script&lang=js"
export * from "./FoodMapView.vue?vue&type=script&lang=js"

import "./FoodMapView.vue?vue&type=style&index=0&id=56d26425&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.16_webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d26425"]])

export default __exports__